<script lang="ts">
  import { createEventDispatcher } from 'svelte';
  // @ts-ignore
  import * as DropdownMenu from '$lib/components/ui/dropdown-menu';
  // @ts-ignore
  import { Button } from '$lib/components/ui/button';
  import Icon from '$shared/icons/Icon.svelte';

  export let label = 'Move';
  export let isFirst = false;
  export let isLast = false;
  export let moveTopLabel = 'Move to top';
  export let moveUpLabel = 'Move up';
  export let moveDownLabel = 'Move down';
  export let moveBottomLabel = 'Move to bottom';

  const dispatch = createEventDispatcher();
</script>

<DropdownMenu.Root onOpenChange={(open) => { if (open) dispatch('opening'); }}>
  <DropdownMenu.Trigger asChild let:builder>
    <Button builders={[builder]} variant="ghost" size="icon" class="w-8 h-8 p-0">
      <span class="sr-only">{label}</span>
      <Icon icon="ArrowUpDown" size="small" />
    </Button>
  </DropdownMenu.Trigger>
  <DropdownMenu.Content align="end">
    <DropdownMenu.Item class="cursor-pointer" disabled={isFirst} on:click={() => dispatch('move', 'top')}>
      <Icon icon="ChevronsUp" size="small" iconClass="mr-1" />{moveTopLabel}
    </DropdownMenu.Item>
    <DropdownMenu.Item class="cursor-pointer" disabled={isFirst} on:click={() => dispatch('move', 'up')}>
      <Icon icon="ChevronUp" size="small" iconClass="mr-1" />{moveUpLabel}
    </DropdownMenu.Item>
    <DropdownMenu.Item class="cursor-pointer" disabled={isLast} on:click={() => dispatch('move', 'down')}>
      <Icon icon="ChevronDown" size="small" iconClass="mr-1" />{moveDownLabel}
    </DropdownMenu.Item>
    <DropdownMenu.Item class="cursor-pointer" disabled={isLast} on:click={() => dispatch('move', 'bottom')}>
      <Icon icon="ChevronsDown" size="small" iconClass="mr-1" />{moveBottomLabel}
    </DropdownMenu.Item>
  </DropdownMenu.Content>
</DropdownMenu.Root>
